import { AbstractAnalyticsTracker } from '@inter-ikea-kompis/analytics';
import { IpexMomentEnum } from '@insights/insights-data-provider';
const moduleId = 'financial_services';
/**
 * Tracks events from Financial Services and sends them to a reporter.
 *
 * @event financial_services_open_sheet When financial services link is clicked.
 * @event financial_services_more_info When financial services read more link is clicked.
 */
export default class FinancialServicesTracker extends AbstractAnalyticsTracker {
    /**
     * @param options ...
     * @param options.dev ...
     * @param options.ab ...
     * @param options.settings ...
     * @param options.locale ...
     * @param options.reporterId ...
     * @param options.context The context where the {@link FinancialServices} component is rendered, e.g. 'main_page', or 'summary_page'. This is used to distinguish the analytics data if the component is used in several places in a planner.
     */
    constructor(options) {
        super({ moduleId, ...options });
        this.context = options.context;
    }
    /**
     * Call to report the financial services link is clicked.
     */
    sendOpenSheet() {
        this.getReporter().report({
            event: 'financial_services_open_sheet',
            ipexMoment: IpexMomentEnum.showMe,
            payload: { context: this.context }
        });
    }
    /**
     * Call to report the financial services read more link is clicked.
     */
    sendMoreInfoClick() {
        this.getReporter().report({
            event: 'financial_services_more_info',
            ipexMoment: IpexMomentEnum.showMe,
            payload: { context: this.context }
        });
    }
}
//# sourceMappingURL=FinancialServicesTracker.js.map